import React, { Component, Fragment } from 'react';
import './StatsNumber.scss';

class StatsNumber extends Component {
    deltaLastWeek() {
        let delta = this.props.current - this.props.lastWeek;

        return delta > 0 ? '+' + delta : delta;
    }

    render() {
        const { current, fromNowOn } = this.props;

        return (
            <div className={'stats-number'}>
                <span className={'current-stats-number'}>{current}</span>
                <span className={'last-week-stats'}>
                    {fromNowOn ? (
                        // A sandbox has no week before its first run to be compared with: the difference would only read as growth
                        <span className={'last-week-test'}>
                            Activity from now on
                        </span>
                    ) : (
                        <Fragment>
                            <span className={'last-week-number'}>
                                {this.deltaLastWeek()}
                            </span>
                            <span className={'last-week-test'}>
                                From last week
                            </span>
                        </Fragment>
                    )}
                </span>
            </div>
        );
    }
}

export default StatsNumber;
